import e, { forwardRef as f } from "react";
import { Alert as C } from "../alert/alert.esm.js";
import { TypographyComponent as g } from "../typography/typography-component.esm.js";
import { useNamedId as z } from "../utils/hooks/useId.esm.js";
const G = "_radioGroup_z9d11_1", I = "_radioLegend_z9d11_5", y = "_radioAlert_z9d11_9", N = "_radioContainer_z9d11_21", v = "_radioContainerStacked_z9d11_25", A = "_radioContainerInline_z9d11_29", a = {
  radioGroup: G,
  radioLegend: I,
  radioAlert: y,
  radioContainer: N,
  radioContainerStacked: v,
  radioContainerInline: A
}, E = f(
  ({
    children: d,
    className: t = "",
    dataTestId: n = "",
    errorMessage: o = "",
    groupName: s,
    legend: r = "",
    stacked: l = !0,
    ..._
  }, u) => {
    const i = z("fuse-radio-group-alert"), c = [a.radioGroup, "fuse-radio-group", t].filter(Boolean).join(" "), p = [
      a.radioContainer,
      l ? a.radioContainerStacked : a.radioContainerInline,
      "fuse-radio-group__radio-container"
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ e.createElement(
      "fieldset",
      {
        className: c,
        "data-testid": n || "fuse-radio-group",
        ref: u,
        ..._
      },
      !!r && /* @__PURE__ */ e.createElement(
        g,
        {
          className: `${a.radioLegend} fuse-radio-group__legend`,
          "data-testid": "fuse-radio-group__legend",
          size: { xxs: "m1", m: "1" },
          tag: "legend",
          type: "heading"
        },
        r
      ),
      !!o && /* @__PURE__ */ e.createElement(
        C,
        {
          className: `${a.radioAlert} fuse-radio-group__alert`,
          "data-testid": "fuse-radio-group__alert",
          id: i,
          message: o,
          role: "alert",
          disableIcon: !0,
          size: "small",
          variant: "error"
        }
      ),
      /* @__PURE__ */ e.createElement("div", { className: p, "data-testid": "fuse-radio-group__radio-container" }, e.Children.map(
        d,
        (m) => e.cloneElement(m, {
          "aria-describedby": o ? i : void 0,
          "aria-invalid": o ? !0 : void 0,
          name: s
        })
      ))
    );
  }
);
E.displayName = "RadioGroup";
export {
  E as RadioGroup
};
